import React from 'react';

import { useDeviceTypes } from '@travel/traveler-core/hooks';
import { ImagePlaceHolder } from '@travel/ui';
import type { GalleryMedia } from '@travel/ui/components/Gallery';

import RoomPlanGalleryCover from '../RoomPlanGalleryCover';

import styles from './roomPlanItemHeader.module.scss';

type Props = {
  title?: string;
  displayImage?: GalleryMedia;
  media: Array<GalleryMedia>;
  onDisplayGallery: (index: number) => void;
  infoComponent?: JSX.Element;
  onDisplayDetail: () => void;
  /** is first */
  isFirst: boolean;
};

function RoomPlanItemHeader(props: Props) {
  const {
    title,
    displayImage,
    media,
    onDisplayGallery,
    infoComponent,
    onDisplayDetail,
    isFirst,
  } = props;

  const { isSP } = useDeviceTypes();

  const nameButton = (
    <div className={styles.nameButtonWrapper}>
      <button
        className={styles.nameButton}
        onClick={onDisplayDetail}
        data-testid="roomPlanItemHeader-nameButton"
      >
        <h3 className={styles.name} data-testid="roomPlanItemHeader-name">
          {title}
        </h3>
      </button>
    </div>
  );

  return (
    <>
      <div className={styles.wrapper} data-testid="providerInfo-roomPlanItemHeader">
        {!isSP && nameButton}
        <div className={styles.detailsWrapper}>
          {displayImage ? (
            <RoomPlanGalleryCover
              medias={media}
              onOpenGallery={onDisplayGallery}
              onOpenDetail={onDisplayDetail}
              isFirst={isFirst}
            />
          ) : !isSP ? (
            <ImagePlaceHolder className={styles.imagePlaceHolder} />
          ) : null}
          {!isSP && infoComponent}
        </div>
      </div>
      {isSP && nameButton}
      {isSP && <div className={styles.infoBox}>{infoComponent}</div>}
    </>
  );
}

export default RoomPlanItemHeader;
